import { useQuery } from '@tanstack/vue-query';
import { queries } from '~/keys';

export type ExclusiveManager = {
  name: string;
  phone: string;
  photoUrl: string | null;
  whatsappUrl: string;
  callUrl: string;
};

type ExclusiveManagerResponse = { success: boolean; data: ExclusiveManager };

const MANAGER_STALE_MS = 10 * 60_000;

// Exclusive Manager contact (ID-176). Only fetched where exclusives are shown; 401/403 → hidden.
export const useExclusiveManagerQuery = (enabled: MaybeRefOrGetter<boolean>) => {
  const authStore = useAuthStore();

  return useQuery({
    ...queries.exclusiveUnits.manager,
    queryFn: async () =>
      (
        await $fetch<ExclusiveManagerResponse>('/api/exclusives/manager', {
          headers: { Authorization: `Bearer ${authStore.token}` },
        })
      ).data,
    enabled: computed(() => !!authStore.token && toValue(enabled)),
    staleTime: MANAGER_STALE_MS,
    retry: false,
    throwOnError: false,
  });
};
